import { useRouteError } from "react-router-dom";
import { Flex, Heading, Text } from "@chakra-ui/react";

export default function ErrorPage() {
  const error = useRouteError() as Record<string, any> | undefined | null;
  const errorMessage = error?.statusText || error?.message;
  console.error(error);

  return (
    <Flex
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={10}
      w="100vw"
      h="100vh"
    >
      <Heading as="h2" size="3xl">
        Oops!
      </Heading>
      <Heading as="h3" size="xl">
        Sorry, an unexpected error has occurred.
      </Heading>
      <Text as="i">{errorMessage}</Text>
    </Flex>
  );
}
